import React from "react";
import { capitalize, Card, Typography } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import Div from "@jumbo/shared/Div";
import JumboDdMenu from "@jumbo/components/JumboDdMenu";
import { useNavigate } from "react-router-dom";
import { capitalizeString } from "app/utils/functions";

const Item = ({ children, sx }) => (
  <Div sx={{ p: (theme) => theme.spacing(1, 2), ...sx }}>{children}</Div>
);

const EnvolvidosListCard = ({ envolvido, deleteEnvolvido }) => {
  const navigate = useNavigate();
  return (
    <Card sx={{ my: 1 }}>
      <Stack direction={"row"} alignItems={"center"} sx={{ p: 2 }}>
        <Item>
          <Avatar
            sx={{ width: 56, height: 56 }}
            alt={`${envolvido?.nome_identificacao}`}
            src={envolvido?.imgUrl}
          />
        </Item>
        <Item
          sx={{
            flexBasis: "30%",
          }}
        >
          <Typography variant={"h6"} mb={0.5}>
            {envolvido?.nome_identificacao}
          </Typography>
          <Typography variant={"body1"} color="text.secondary">
            Nome / Identificação
          </Typography>
        </Item>
        <Item
          sx={{
            flexBasis: "12%",
            marginRight: "auto",
          }}
        >
          <Typography variant={"h6"} mb={0.5}>
            {capitalizeString(envolvido?.tipo_pessoa) ?? 'N/I'}
          </Typography>
          <Typography variant={"body1"} color="text.secondary">
            Tipo pessoa
          </Typography>
        </Item>        <Item
          sx={{
            flexBasis: "12%",
            marginRight: "auto",
          }}
        >
          <Typography variant={"h6"} mb={0.5}>
            {capitalizeString(envolvido?.tipo_envolvido) ?? 'N/I'}
          </Typography>
          <Typography variant={"body1"} color="text.secondary">
            Tipo envolvido
          </Typography>
        </Item>        <Item
          sx={{
            flexBasis: "15%",
            marginRight: "auto",
          }}
        >
          <Typography variant={"body1"} mb={0.5} fontWeight="600">
            {envolvido?.telefone || 'N/I'}
          </Typography>
          <Typography variant={"body2"} color="text.secondary">
            Telefone
          </Typography>
        </Item>
        <Item
          sx={{
            flexBasis: "20%",
            marginRight: "auto",
          }}
        >
          <Typography variant={"body1"} mb={0.5} fontWeight="600">
            {envolvido?.email || 'N/I'}
          </Typography>
          <Typography variant={"body2"} color="text.secondary">
            Email
          </Typography>
        </Item>
        <Item>
          <JumboDdMenu
            menuItems={[
              {
                title: "Visualizar",
                slug: "visualizar",
                onClickItem: () => {

                },
              },
              {
                title: "Editar",
                slug: "editar",
                onClickItem: () => {
                  navigate(`/envolvido/${envolvido.id}`);
                },
              },
              {
                title: "Excluir",
                slug: "Excluir",
                onClickItem: () => {
                  deleteEnvolvido(envolvido.id);
                },
              },
            ]}
          />
        </Item>
      </Stack>
    </Card>
  );
};

export default EnvolvidosListCard;
